import { render, staticRenderFns } from "./SuperClientesComponent.vue?vue&type=template&id=b385cf98&"
import script from "./SuperClientesComponent.vue?vue&type=script&lang=js&"
export * from "./SuperClientesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports